import React, { Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import AppTitle from '../../../atoms/app-title';
import SavedConfigurationsList from '../../../components/saved_configurations_list';
import {
  createEmptyConfiguration, reopenConfiguration, setActiveStep,
  setStarterType, deleteConfiguration, renameConfiguration, duplicateConfiguration, cancelConfiguration,
  shareConfiguration,
  createEmptySoftwareLicenceConfiguration,
  createSoftwareLicenceConfigurationFromSoftware
} from '../../configuration-management/ducks';
import { exportToXLS, exportToMyProduct, exportToMyProject, exportToMyList } from '../../export/ducks';
import { stepsConfig, possible_starter_selections, call_by_range_category_range_mapping, tool_starter_selections, TOOL_MAIN_TECHNOLOGIES, call_by_range_category_id_mapping, IAC_SEND_MAIL_EVENT_NAMES } from '../../../constants';
import { openModal, closeModal } from '../../modals/ducks';
import { getSavedConfigurations, getSavedConfigurationByID, updateHandleConfigurationRestore, updateShowButtonAnimations } from './ducks';
import I10n from '../../../features/i10n';
import { showNotificationWithButton } from '../../notification/ducks';
import convertName from '../../../utils/convert-name';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { appConfiguration, setDisableCallByRangeBackToStart } from '../../../utils/app-starter';
import { setUserInformation, getUserInformation } from '../../user-information/ducks';
import { convertDate } from '../../../utils/date';
import { logCreateConfigurationEvent, logCreateSoftwareLicenceConfigurationEvent, logReopenedConfiguration, raiseIACAnalyticsEvent } from '../../../utils/analytics-logger';
import Configuration from '../../../models/Configuration';
import { getCartUrl } from '../../../utils/my-product';
import Button from '../../../atoms/button';
import MsxIcons from '../../msx-icons';
import { setCBRSelectedItems, resetCBRSelectedItems } from '../../call-by-range/ducks';
import CallByRange from '../../../components/call_by_range';
import DropdownMenu from '../../../components/dropdown_menu';
import InformationIcon from '../../../atoms/information-icon';
import LoginBanner from '../../../components/login-banner';

import { buildMySchneiderUrlWithCBR } from '../../../utils/url-builder';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../../color-constants';
import { shouldDisplaySoftwareLicenseData } from '../../../utils/software-licenses';
import StartConfigurationCard from '../../../components/application-cards/start-configuration-card';

const Wrapper = styled.div`
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TabWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  margin-right: -16px;
  margin-left: -16px;
  margin-top: 40px;
  @media (max-width: 800px) {
    display: none;
    margin-top: 30px;
  }
`;

const TabItem = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 0px;
  justify-content: center;
  border-top: 2px solid white;
  border-bottom: 2px solid #FAFAFA;
  ${props => props.selected ? `
    background-color: #FAFAFA;
    border-top: 2px solid #FAFAFA;
    border-bottom: 2px solid ${SECONDARY_COLOR};
    border-bottom: 2px solid var(--se-primary, ${SECONDARY_COLOR});
  ` : `
    :hover {
      background-color: #F3F2F2;
    }
  `}
  cursor: pointer;
  padding: 8px;
`;

const TabTitle = styled.span`
  font-weight: 700;
  font-size: 18px;
  color: #333333;
  text-align: center;
`;

const WorkSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  margin-right: -16px;
  margin-left: -16px;
  padding: 16px;
  background-color: #FAFAFA;
  @media (max-width: 800px) {
    display: none;
  }
`;

const ConfigurationStarterOptions = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-wrap: wrap;
  margin-right: -15px;
  @media (max-width: 800px) {
    flex-direction: column;
    margin-right: -10px;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  width: calc(33% - 10px);
  margin-bottom: 10px;
  margin-right : 10px;
  min-width: 200px;
  @media (max-width: 800px) {
    min-width: unset;
    flex: unset;
    width: auto;
  }
`;

const ScreenContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 25px;
    @media (max-width: 800px) {
      padding-top: 30px;
    }
`;

const HMCTitle = styled.span`
    font-size: 14px;
    margin-right: 10px;
    font-weight: 400;
    color: #626469;
`;

const HMCWrapper = styled.div`
    display: flex;
    margin-bottom: 20px;
`;

const HMCIconAndTitleWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    :hover {
      ${HMCTitle} {
        text-decoration: underline;
      }
    }
`;

const HMCInfoIconWrapper = styled.div`
    background-color: ${PRIMARY_COLOR};
    color: white;
    padding: 5px;
    border-radius: 50%;
    margin-right: 5px;
`;

const FiltersAppliedWrapper = styled.div`
  display: inline-flex;
  padding: 5px 10px;
  background-color: #EDEDED;
  border-radius: 0px 100px 100px 0px;
  margin: 10px 0px;
  align-items: center;
`;

const FilterAppliedLabel = styled.span`
  display: inline-block;
  color: #4D4E53;
  font-size: 12px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  margin-right: 10px;
`;

const FilterAppliedContent = styled.div`
    padding: 10px 10px 5px 10px;
`;

const FACTitle = styled.span`
  display: block !important;
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
  margin-bottom: 10px;
`;

const FacLabel = styled.span`
  display: block !important;
  font-weight: 400;
  font-size: 14px;
  white-space: nowrap;
  margin-bottom: 5px;
`;

const MobileWorkSection = styled.div`
  display: none;
  flex-direction: column;
  @media (max-width: 800px) {
    display: flex;
    margin-top: 20px;
  }
`;

const MobileCategoryDropdown = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  border: 1px solid #E6E6E6;

  ${props => props.isOpen ?
    `color: ${SECONDARY_COLOR};
     margin-bottom: 10px;` :
    `background-color: #FAFAFA;color: #626469;`}
`;

const CategoryDropdownLabel = styled.span`
  font-weight: bold;
  font-size: 16px;
`;

const ArrowIconWrapper = styled.div`
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  width: 32px;
  height: 32px;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobileLoginWrapper = styled.div`
  visibility: hidden;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  @media (max-width: 800px) {
    visibility: visible;
  }
`;

const LoginText = styled.span`
  font-weight: 400;
  font-size: 15px;
  color: #626669;
  margin-bottom: 10px;
  text-align: center;
`;

const ConfigurationOptionsCategory = styled.span`
  font-weight: 700;
  font-size: 22px;
  color: #626469;
  margin: 20px 0px;
`;

const LoginBannerWrapper = styled.div`
  display: flex;
  margin: 0px -16px -16px -16px;
`;

const possible_tab_states = {
  technologies: 0,
  openConfigurations: 1
}

class StartConfigurationScreen extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = true;
    this.state = {
      starterType: null,
      isLoading: true,
      configurationIdParam: appConfiguration.configurationId,
      configurationsPayload: null,
      modalLoginOpen: false,
      tabState: possible_tab_states.technologies,
      mobileStartConfigurationOpen: false,
      mobileSavedConfigurationsOpen: false
    };
  }

  componentDidMount() {
    this.onStartUp();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  processPreSelectedFilters = (shouldRedirect) => {
    const availableCallByRangeItems = this.buildCallByRangeAvailabilities();
    let technologyToStart;

    if (appConfiguration.startPageFilters.references.length > 0) {
      const availableReferences = availableCallByRangeItems.references.filter(availableRef => appConfiguration.startPageFilters.references.includes(availableRef));
      const foundTechnologiesKeys = {};
      const technoKeys = Object.keys(appConfiguration.availableRanges);

      for (const refToCheck of availableReferences) {
        for (let i = 0; i < technoKeys.length; i++) {
          let techno = technoKeys[i];
          let rangesForTechnology = appConfiguration.availableRanges[techno];
          for (let j = 0; j < rangesForTechnology.length; j++) {
            if (rangesForTechnology[j].references.map(ref => ref.id).includes(refToCheck)) {
              foundTechnologiesKeys[techno] = true;
            }
          }
        }
      }

      this.setCBRMultipleItems(availableReferences, 'references');
      const foundTechnologies = Object.keys(foundTechnologiesKeys);
      if (foundTechnologies.length === 1) {
        technologyToStart = foundTechnologies[0].toUpperCase();
      }
    } else if (appConfiguration.startPageFilters.ranges.length > 0) {
      //Eventually convert real range ids to our custom range ids;
      const customRanges = [];
      appConfiguration.startPageFilters.ranges.forEach((rangeId) => {
        if (call_by_range_category_id_mapping[rangeId] != null) {
          customRanges.push(...call_by_range_category_id_mapping[rangeId]);
        } else {
          customRanges.push(rangeId);
        }
      });
      const availableRanges = availableCallByRangeItems.ranges.filter(availableRange => customRanges.includes(availableRange));
      const foundTechnologiesKeys = {};
      const technoKeys = Object.keys(appConfiguration.availableRanges);

      for (const rangeToCheck of availableRanges) {
        for (let i = 0; i < technoKeys.length; i++) {
          let techno = technoKeys[i];
          let rangesForTechnology = appConfiguration.availableRanges[techno];
          if (rangesForTechnology.map(range => range.translationKey).includes(rangeToCheck)) {
            foundTechnologiesKeys[techno] = true;
          }
        }
      }

      this.setCBRMultipleItems(availableRanges, 'ranges');
      const foundTechnologies = Object.keys(foundTechnologiesKeys);

      if (foundTechnologies.length === 1) {
        technologyToStart = foundTechnologies[0].toUpperCase();
      }
    } else if (appConfiguration.startPageFilters.technologies.length > 0) {
      // Here we transform the technology coming from params to uppercase in order to allow both capital and small letters. (PLC/plc, PAC/pac, SOFTWARE_LICENCE/software_licence)
      const availableTechnologies = availableCallByRangeItems.technologies.filter(availableTech => appConfiguration.startPageFilters.technologies.map(tech => tech.toUpperCase()).includes(availableTech));
      if (availableTechnologies.length === 1) {
        technologyToStart = availableTechnologies[0];
      } else {
        this.setCBRMultipleItems(availableTechnologies, 'technologies');
      }
    }

    if (shouldRedirect && technologyToStart && !appConfiguration.ignoreParametersRedirection) {
      const selectedCBRItems = JSON.parse(JSON.stringify(this.props.callByRangeReducer.selectedItems));
      if (tool_starter_selections.modicon_controller.includes(technologyToStart)) {
        if (appConfiguration.preventCallByRangeBackToStart) {
          setDisableCallByRangeBackToStart(true);
        }
        this.props.selectStarter(technologyToStart);
        this.props.createEmptyConfiguration().then((payload) => {
          logCreateConfigurationEvent(payload?.configuration?.id, technologyToStart, this.buildCBREventPayload(selectedCBRItems));
        });
      } else if (tool_starter_selections.industrial_automation_software.includes(technologyToStart)) {
        this.props.createEmptySoftwareLicenceConfiguration().then((payload) => {
          logCreateSoftwareLicenceConfigurationEvent(payload?.configuration?.id, technologyToStart, this.buildCBREventPayload(selectedCBRItems));
        });
      }
    }
  }

  handleModiconStartParameters = () => {
    let technology;
    if (appConfiguration.searchType && appConfiguration.searchType === possible_starter_selections.PAC) {
      technology = possible_starter_selections.PAC;
    } else {
      technology = possible_starter_selections.PLC_IO;
    }
    this.props.selectStarter(technology);
    this.props.createEmptyConfiguration().then((payload) => {
      logCreateConfigurationEvent(payload?.configuration?.id, technology, {});
    });
  }

  onStartUp = () => {
    window.scrollTo(0, 0);
    setDisableCallByRangeBackToStart(false);
    this.props.resetCallByRangeSelectedItems();
    this.props.resetShowButtonAnimations();
    this.props.setApplicationParameters({ fullScreenEnabled: true });

    const shouldHandleDefaultSearchParameters = this.props.shouldHandleDefaultSearchParameters;
    // This works because the reset dispatch will be triggered after this function call.
    if (shouldHandleDefaultSearchParameters || appConfiguration.launchFromWorkspace) {
      this.processPreSelectedFilters(this.props.shouldHandleDefaultSearchParameters);
    }

    // Same as before.
    if (shouldHandleDefaultSearchParameters && appConfiguration.plcSearch && !appConfiguration.ignoreParametersRedirection) {
      this.handleModiconStartParameters();
    } else {
      this.getSavedConfigurations();
    }
  }

  getReopenRangeText = (lastActiveConfiguration) => {
    let rangeText = I10n.getOrDefault(`ranges.${lastActiveConfiguration.headModuleRange}`, lastActiveConfiguration.headModuleRange, 'data');
    if (possible_starter_selections.SOFTWARE_LICENCE === lastActiveConfiguration.configurationType) {
      rangeText = I10n.getOrDefault(`category.${lastActiveConfiguration.softwareSelection}.name`, lastActiveConfiguration.softwareSelection, 'data');
    }
    return rangeText;
  }

  getReopenConfigurationText = (lastActiveConfiguration) => {
    let rangeText = this.getReopenRangeText(lastActiveConfiguration);
    const translationKey = appConfiguration.seamlessSession ? 'screen.start_configuration_screen.incomplete_seamless_configuration.modal_body' : 'screen.start_configuration_screen.incomplete_configuration.modal_body';
    return I10n.getAndReplaceMultiple(translationKey, [rangeText, convertDate(lastActiveConfiguration.date)]);
  }

  handleGetConfigurationPayload = (payload) => {
    const lastActiveConfiguration = payload.activeConfiguration;
    const lastActiveSeamlessConfiguration = payload.seamlessActiveConfiguration;
    if (lastActiveConfiguration && !this.props.configurationSaver.isSaving) {
      this.showReopenConfigurationModal(lastActiveConfiguration, this.getReopenConfigurationText(lastActiveConfiguration));
    } else if (lastActiveSeamlessConfiguration && !this.props.configurationSaver.isSaving) {
      this.showReopenConfigurationModal(lastActiveSeamlessConfiguration, I10n.getAndReplaceMultiple('screen.start_configuration_screen.incomplete_configuration.modal_body', [this.getReopenRangeText(lastActiveSeamlessConfiguration), convertDate(lastActiveSeamlessConfiguration.date)]));
    }
  }

  getSavedConfigurations = () => {
    this.props.getSavedConfigurations().then((payload) => {
      if (this.props.shouldHandleConfigurationRestore && this._isMounted) {
        if (this.state.configurationIdParam) {
          this.onConfigurationReopen(this.state.configurationIdParam);
        } else {
          this.updateStateIfMounted({ configurationsPayload: payload });
          if (!this.state.modalLoginOpen) {
            this.handleGetConfigurationPayload(payload);
          }
        }
      }
    }).catch((err) => {
    }).finally(() => {
      this.updateStateIfMounted({ isLoading: false });
      this.props.updateHandleConfigurationRestore(false);
    });
  }

  onConfigurationReopen = (configurationID, step = stepsConfig.save_screen) => {
    this.updateStateIfMounted({ isLoading: true });
    this.props.getSavedConfigurationByID(configurationID).then((payload) => {
      payload.step = step;
      this.props.resetCallByRangeSelectedItems();
      this.props.reopenConfiguration(payload);
      logReopenedConfiguration(configurationID);
    }).catch(() => {
      this.props.openModal({
        modalType: 'information',
        modalProps: {
          onButtonClick: () => { this.props.closeModal(); },
          title: I10n.get('modal.error.configuration.does_not_exist.title'),
          text: I10n.get('modal.error.configuration.does_not_exist.body'),
          buttonText: I10n.get('app.action.close'),
        }
      });
    }).finally(() => {
      this.updateStateIfMounted({ isLoading: false });
    });
  }

  showReopenConfigurationModal = (configuration, modalText) => {
    this.props.openModal({
      modalType: 'confirmation',
      modalProps: {
        onCancel: () => { this.props.closeModal(); this.props.cancelConfiguration(configuration.id); },
        onSubmit: () => {
          this.props.getSavedConfigurationByID(configuration.id).then((payload) => {
            this.props.closeModal();
            this.props.resetCallByRangeSelectedItems();
            this.props.reopenConfiguration(payload);
          }).catch(() => {
            this.props.closeModal();
          });
        },
        title: I10n.get('screen.start_configuration_screen.incomplete_configuration.modal_title'),
        text: modalText,
        cancelText: I10n.get('app.action.cancel'),
        submitText: I10n.get('app.action.continue'),
      }
    });
  }

  onConfigurationDuplicate = (configurationId) => {
    this.props.resetCallByRangeSelectedItems();
    this.updateStateIfMounted({ isLoading: true });
    duplicateConfiguration(configurationId).then((payload) => {
      this.updateStateIfMounted({ isLoading: false });
      this.props.reopenConfiguration(payload);
    }).catch(() => {
      this.updateStateIfMounted({ isLoading: false });
    });
  }

  onConfigurationRename = (configuration, newName) => {
    const convertedName = convertName(newName);
    if (configuration.name !== convertedName) {
      this.updateStateIfMounted({ isLoading: true });
      this.props.renameConfiguration(configuration.id, convertedName).then(() => {
        this.getSavedConfigurations();
      }).catch(() => {
        this.updateStateIfMounted({ isLoading: false });
      })
    }
  }

  onConfigurationDelete = (configurationId) => {
    this.updateStateIfMounted({ isLoading: true });
    deleteConfiguration(configurationId).then(() => {
      this.getSavedConfigurations();
    })
      .catch(() => {
        this.updateStateIfMounted({ isLoading: false });
      })
  }

  performAddToCart = (configuration) => {
    if (appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable) {
      this.props.exportToMyProject(configuration);
    } else {
      const x = this.props.exportToMyProduct(configuration);
      x.then(() => {
        // Don't show notification and cart link on partner website / MySchneider
        if (window.top === window.self) {
          this.props.showNotification(
            I10n.get('add_to_my_product.notification'),
            'success',
            () => (
              <Button onClick={() => { window.open(getCartUrl(), '_blank'); }}>
                {I10n.get('add_to_my_product.notification.button')}
              </Button>
            )
          );
        }
      }).catch(() => {
        this.props.showNotification(
          I10n.get('add_to_my_product.notification.error'),
          'error'
        );
      });
    }
  }

  addToMyProduct = (configuration) => {
    this.props.getSavedConfigurationByID(configuration.id).then((payload) => {
      const config = new Configuration(payload);
      if (config.containsPrecommercializedProducts()) {
        this.props.openModal({
          modalType: 'confirmation',
          modalProps: {
            onCancel: () => {
              this.props.closeModal();
            },
            onSubmit: () => {
              this.performAddToCart(config);
              this.props.closeModal();
            },
            title: I10n.get('important_information'),
            text: I10n.get((appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable || appConfiguration.launchFromWorkspace) ? 'precommercialized_products_warning.body.project_builder' : 'precommercialized_products_warning.body'),
            cancelText: I10n.get('app.action.cancel'),
            submitText: I10n.get('app.action.continue'),
          }
        });
      } else {
        this.performAddToCart(config);
      }
    });
  }

  addToList = (configuration) => {
    this.props.getSavedConfigurationByID(configuration.id).then((payload) => {
      const config = new Configuration(payload);
      if (config.containsPrecommercializedProducts()) {
        this.props.openModalFct({
          modalType: 'confirmation',
          modalProps: {
            onCancel: () => {
              this.props.closeModal();
            },
            onSubmit: () => {
              this.props.exportToMyList(config);
              this.props.closeModal();
            },
            title: I10n.get('important_information'),
            text: 'precommercialized_products_warning.body',
            cancelText: I10n.get('app.action.cancel'),
            submitText: I10n.get('app.action.continue'),
          }
        });
      } else {
        this.props.exportToMyList(config);
      }
    });


  }

  onSendMail = (configuration) => {
    const mailInformation = getUserInformation();
    this.props.openModal({
      modalType: 'send-email',
      modalProps: {
        senderName: mailInformation.senderName,
        senderEmail: mailInformation.senderEmail,
        onCancel: () => { this.props.closeModal(); },
        onSubmit: (formData) => {
          this.props.closeModal();
          const configurationId = configuration.id;
          const configurationName = configuration.name;
          setUserInformation(formData.senderEmail, formData.senderName);
          let sharePromise;
          if (formData.sendToMyself) {
            sharePromise = shareConfiguration(configurationId, formData.senderEmail, formData.senderName, null, null, null, formData.captchaResponse, true, I10n.get('save_configuration.email.subject'));
          } else {
            sharePromise = shareConfiguration(configurationId, formData.senderEmail, formData.senderName, formData.recipientEmail, formData.recipientName, formData.message, formData.captchaResponse, true, I10n.get('save_configuration.email.subject'));
          }
          sharePromise.then(() => {
            raiseIACAnalyticsEvent(IAC_SEND_MAIL_EVENT_NAMES.SEND_MAIL);
            this.props.showNotification(I10n.getAndReplace('save_configuration.email_sent.notification', configurationName), 'succes', () => null);
          })
            .catch((error) => {
              console.log(error);
            });
        },
      }
    });
  }

  buildOptionTypes = (availableCallByRangeItems) => {
    const selectedTechnologies = this.props.callByRangeReducer?.selectedItems?.technologies ? Object.keys(this.props.callByRangeReducer.selectedItems.technologies) : [];
    let optionTypes = [...availableCallByRangeItems.technologies];

    if (selectedTechnologies.length > 0) {
      optionTypes = optionTypes.filter(o => selectedTechnologies.includes(o));
    }

    return optionTypes;
  }

  buildCallByRangeAvailabilities = () => {
    const selectedTechnologies = this.props.callByRangeReducer?.selectedItems?.technologies ? Object.keys(this.props.callByRangeReducer.selectedItems.technologies) : [];
    const selectedRanges = this.props.callByRangeReducer?.selectedItems?.ranges ? Object.keys(this.props.callByRangeReducer.selectedItems.ranges) : [];
    const selectedReferences = this.props.callByRangeReducer?.selectedItems?.references ? Object.keys(this.props.callByRangeReducer.selectedItems.references) : [];

    let candidateTechnologies = [possible_starter_selections.PLC_IO];
    if (appConfiguration.technologies.pac) {
      candidateTechnologies.push(possible_starter_selections.PAC);
    }

    // Do not activate EDGE for the partners (but for enable it from architecture builder)
    if (appConfiguration.technologies.edge && (window.self === window.top || appConfiguration.startPageFilters.technologies.includes('EDGE'))) {
      candidateTechnologies.push(possible_starter_selections.EDGE);
    }

    // Software should not be shown for distributor only
    if (appConfiguration.technologies.software_licence && (!(window.self !== window.top && !appConfiguration.launchFromWorkspace && !appConfiguration.unifiedCheckoutAvailable))) {
      candidateTechnologies.push(possible_starter_selections.SOFTWARE_LICENCE);
    }

    const mapTechnologyRanges = { [possible_starter_selections.PLC_IO]: appConfiguration.availableRanges.plc, [possible_starter_selections.PAC]: appConfiguration.availableRanges.pac, [possible_starter_selections.EDGE]: appConfiguration.availableRanges.edge, [possible_starter_selections.SOFTWARE_LICENCE]: appConfiguration.availableRanges.software_licence };

    const result = {
      technologies: [],
      ranges: [],
      references: []
    };

    let displayableTechnologies = candidateTechnologies;
    let displayableRanges = [];
    let displayableReferencies = [];

    let rangesToExplore = [];
    let referencesToExplore = [];

    for (const tech of candidateTechnologies) {
      if (selectedTechnologies.length === 0 || selectedTechnologies.includes(tech)) {
        rangesToExplore.push({ tech, ranges: mapTechnologyRanges[tech] });
      }
    }

    let technologiesToKeep = [];
    let rangesToKeep = [];

    for (const rangex of rangesToExplore) {
      const tech = rangex.tech;
      for (const range of rangex.ranges) {
        const rangeKey = range.translationKey;
        displayableRanges.push(rangeKey);
        if (selectedRanges.length === 0 || selectedRanges.includes(rangeKey)) {
          displayableReferencies.push(...range.references.map(ref => ref.id));
          referencesToExplore.push({ tech, rangeKey, references: range.references.map(ref => ref.id) });
        }
        if (selectedRanges.includes(rangeKey) && selectedReferences.length === 0) {
          technologiesToKeep.push(tech);
        }
      }
    }

    for (const refx of referencesToExplore) {
      const tech = refx.tech;
      const rangeKey = refx.rangeKey;
      for (const ref of refx.references) {
        if (selectedReferences.includes(ref)) {
          technologiesToKeep.push(tech);
          rangesToKeep.push(rangeKey);
        }
      }
    }

    technologiesToKeep = technologiesToKeep.filter(function (item, pos) {
      return technologiesToKeep.indexOf(item) === pos;
    });

    rangesToKeep = rangesToKeep.filter(function (item, pos) {
      return rangesToKeep.indexOf(item) === pos;
    });

    if (selectedRanges.length > 0 || selectedReferences.length > 0) {
      displayableTechnologies = displayableTechnologies.filter(value => technologiesToKeep.includes(value));
    }

    if (selectedReferences.length > 0) {
      displayableRanges = displayableRanges.filter(value => rangesToKeep.includes(value));
    }

    result.technologies = displayableTechnologies;
    result.ranges = displayableRanges;
    result.references = displayableReferencies;

    return result;
  }

  clearCBRCategory = (category) => {
    const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));
    if (newValue.selectedItems[category]) {
      newValue.selectedItems[category] = {};
    }

    this.props.setCallByRangeSelectedItems(newValue);
  }

  setCBRMultipleItems = (values, category) => {
    const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));
    if (newValue.selectedItems[category]) {
      // Reset the category
      newValue.selectedItems[category] = {};
      for (const value of values) {
        newValue.selectedItems[category][value] = true;
      }
      this.props.setCallByRangeSelectedItems(newValue);
    }
  }

  setCBRItem = (value, category) => {
    const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));
    if (newValue.selectedItems[category]) {
      if (newValue.selectedItems[category][value] == null) {
        newValue.selectedItems[category][value] = true;
      } else {
        delete newValue.selectedItems[category][value];
      }
    }
    if (!this.state.mobileSavedConfigurationsOpen) {
      this.updateStateIfMounted({ mobileStartConfigurationOpen: true });
    }
    this.props.setCallByRangeSelectedItems(newValue);
  }

  filterConfigurations = () => {

    let configurations = this.props.savedConfigurations.configurations.filter(configuration => {
      // Hide software configurations only on distributor mode (show in project builder).
      return (window.top === window.self || appConfiguration.launchFromWorkspace || appConfiguration.unifiedCheckoutAvailable) || configuration.softwareSelection == null;
    });

    const selectedTechnologies = this.props.callByRangeReducer?.selectedItems?.technologies ? Object.keys(this.props.callByRangeReducer.selectedItems.technologies) : [];
    const selectedRanges = this.props.callByRangeReducer?.selectedItems?.ranges ? Object.keys(this.props.callByRangeReducer.selectedItems.ranges) : [];
    const selectedReferences = this.props.callByRangeReducer?.selectedItems?.references ? Object.keys(this.props.callByRangeReducer.selectedItems.references) : [];

    if (selectedReferences.length > 0) {
      configurations = configurations.filter(conf => selectedReferences.includes(conf.headModule) ||
        selectedReferences.filter(value => conf.softwareLicences.includes(value)).length > 0                 // For software licences configurations, find if the intersection has at least one element
      );
    } else if (selectedRanges.length > 0) {
      configurations = configurations.filter(conf => {
        let result = false;
        for (let i = 0; i < selectedRanges.length && !result; i++) {
          const range = selectedRanges[i];
          const mappedRanges = call_by_range_category_range_mapping[range] || [];
          if (mappedRanges.includes(conf.headModuleRange) || range === conf.softwareSelection) {
            result = true;
          }
        }
        return result;
      });
    } else if (selectedTechnologies.length > 0) {
      configurations = configurations.filter(conf => selectedTechnologies.includes(conf.starterType) || selectedTechnologies.includes(conf.configurationType));
    }

    return configurations;
  }

  rangesAndReferencesForTechnology = (availableCallByRangeItems, technology) => {
    const selectedRanges = this.props.callByRangeReducer?.selectedItems?.ranges ? Object.keys(this.props.callByRangeReducer.selectedItems.ranges) : [];
    const selectedReferences = this.props.callByRangeReducer?.selectedItems?.references ? Object.keys(this.props.callByRangeReducer.selectedItems.references) : [];

    let rangesToDisplay = [];
    let referencesToDisplay = [];

    const rangesForTechnology = (appConfiguration.availableRanges[technology.toLowerCase()] || []).map(range => range.translationKey);
    if (selectedRanges.length) {
      // Second includes to check if the selected range is not hidden from a reference choice.
      rangesToDisplay = selectedRanges.filter(range => rangesForTechnology.includes(range) && (availableCallByRangeItems.ranges || []).includes(range));
    } else {
      rangesToDisplay = (availableCallByRangeItems.ranges || []).filter(range => rangesForTechnology.includes(range));
    }

    if (selectedReferences.length) {
      const referencesForTechnology = (appConfiguration.availableRanges[technology.toLowerCase()] || []).map(range => range.references).flat().map(ref => ref.id);
      const referencesForTechnologyMap = {};
      referencesForTechnology.forEach(ref => {
        referencesForTechnologyMap[ref] = true;
      })
      referencesToDisplay = selectedReferences.filter(ref => referencesForTechnologyMap[ref] === true);
    }


    return {rangesToDisplay, referencesToDisplay};

  }

  renderFiltersAppliedForTechnology = (availableCallByRangeItems, technology) => {
    const selectedRanges = this.props.callByRangeReducer?.selectedItems?.ranges ? Object.keys(this.props.callByRangeReducer.selectedItems.ranges) : [];
    const selectedReferences = this.props.callByRangeReducer?.selectedItems?.references ? Object.keys(this.props.callByRangeReducer.selectedItems.references) : [];

    const rangesAndReferencesForTechnology = this.rangesAndReferencesForTechnology(availableCallByRangeItems, technology);

    let rangesToDisplay = rangesAndReferencesForTechnology.rangesToDisplay || [];
    let referencesToDisplay = rangesAndReferencesForTechnology.referencesToDisplay || [];

    if (selectedRanges.length + selectedReferences.length === 0) {
      return (<></>);
    }

    return (<FiltersAppliedWrapper>
      <FilterAppliedLabel>{I10n.get('screen.start_configuration_screen.cbr.filters_applied')}</FilterAppliedLabel>
      <DropdownMenu
        toggleElement={<InformationIcon></InformationIcon>}
        containerElement={<FilterAppliedContent>
          {rangesToDisplay.length > 0 && <>
            <FACTitle>{I10n.get('screen.start_configuration_screen.cbr.ranges')}</FACTitle>
            {rangesToDisplay.map((range, idx) => <FacLabel key={idx}>{I10n.get(`category.${range}.name`, 'data')}</FacLabel>)}
          </>}
          {referencesToDisplay.length > 0 && <>
            <FACTitle>{I10n.get('screen.start_configuration_screen.cbr.references')}</FACTitle>
            {referencesToDisplay.map((ref, idx) => <FacLabel key={idx}>{ref}</FacLabel>)}
          </>}

        </FilterAppliedContent>}
      >
      </DropdownMenu>
    </FiltersAppliedWrapper>);
  }

  selectOnlyRangesAndReferencesForTechnology = (availableCallByRangeItems, technology) => {
    const rangesAndReferencesForTechnology = this.rangesAndReferencesForTechnology(availableCallByRangeItems, technology);

    let rangesToDisplay = rangesAndReferencesForTechnology.rangesToDisplay || [];
    let referencesToDisplay = rangesAndReferencesForTechnology.referencesToDisplay || [];

    const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));

    for (const rangeKey of Object.keys(newValue.selectedItems['ranges'])) {
      if (!rangesToDisplay.includes(rangeKey)) {
        delete newValue.selectedItems['ranges'][rangeKey];
      }
    }

    for (const refKey of Object.keys(newValue.selectedItems['references'])) {
      if (!referencesToDisplay.includes(refKey)) {
        delete newValue.selectedItems['references'][refKey];
      }
    }
    this.props.setCallByRangeSelectedItems(newValue);
  }

  buildCBREventPayload (selectedCBRItems) {
    const payload = {};
    const selectedTechnologies = Object.keys(selectedCBRItems.technologies);
    const selectedRanges = Object.keys(selectedCBRItems.ranges);
    const selectedReferences = Object.keys(selectedCBRItems.references);
    if (selectedTechnologies.length > 0) {
      payload.technologies = selectedTechnologies;
    }
    if (selectedRanges.length > 0) {
      payload.ranges = selectedRanges;
    }
    if (selectedReferences.length > 0) {
      payload.references = selectedReferences;
    }
    return payload;
  }

  renderModiconTechnologies = (optionTypes, availableCallByRangeItems) => {

    const options = [];

    optionTypes.filter(opt => tool_starter_selections.modicon_controller.includes(opt)).forEach((optionType) => {
      options.push(
        <CardWrapper key={optionType} lessThan3Options={(optionTypes.length + 1) === 3}>
          <StartConfigurationCard
            id= {optionType + '-configuration-option-starter'}
            title={I10n.get(`screen.start_configuration_screen.create.${optionType}`)}
            description={I10n.get(`screen.start_configuration_screen.create.${optionType}.subtitle`)}
            additionalDescription={I10n.get(`screen.start_configuration_screen.create.${optionType}.additional_description`)}
            startLabel={I10n.get('screen.start_configuration_screen.start_now')}
            active={!this.props.configurationSaver.isSaving && !this.state.isLoading}
            onSelection={() => {
              // Keep all the items selected by the user
              const selectedCBRItems = JSON.parse(JSON.stringify(this.props.callByRangeReducer.selectedItems));
              this.props.selectStarter(optionType);
              this.selectOnlyRangesAndReferencesForTechnology(availableCallByRangeItems, optionType);
              this.props.createEmptyConfiguration().then((payload) => {
                logCreateConfigurationEvent(payload?.configuration?.id, optionType, this.buildCBREventPayload(selectedCBRItems));
              });
            }}
            renderSelectedFilters={() => { return this.renderFiltersAppliedForTechnology(availableCallByRangeItems, optionType) }}
            primaryColor={appConfiguration.globalStyles.primaryColor}
            secondaryColor={appConfiguration.globalStyles.secondaryColor}
          />
        </CardWrapper>
      );
    });

    return (
      <>
        {options.length > 0 && <>
          <ConfigurationOptionsCategory>
            {I10n.get('screen.start_configuration_screen.modicon_controllers')}
          </ConfigurationOptionsCategory>
          {optionTypes.length > 1 && <HMCWrapper>
            <HMCIconAndTitleWrapper onClick={event => {
              this.props.openModal({
                modalType: 'help-me-choose',
                modalProps: {
                  onSelectCategory: (value) => {
                    // Keep all the items selected by the user
                    const selectedCBRItems = JSON.parse(JSON.stringify(this.props.callByRangeReducer.selectedItems));
                    // To avoid no references in next step
                    if (!optionTypes.includes(value)) {
                      this.props.resetCallByRangeSelectedItems();
                    }
                    this.props.closeModal();
                    if (tool_starter_selections.modicon_controller.includes(value)) {
                      this.props.selectStarter(value);
                      this.props.createEmptyConfiguration().then((payload) => {
                        logCreateConfigurationEvent(payload?.configuration?.id, value, this.buildCBREventPayload(selectedCBRItems));
                      });
                    } else if (tool_starter_selections.industrial_automation_software.includes(value)) {
                      this.props.createEmptySoftwareLicenceConfiguration().then((payload) => {
                        logCreateSoftwareLicenceConfigurationEvent(payload?.configuration?.id, value, this.buildCBREventPayload(selectedCBRItems));
                      });
                    }
                  }
                }
              });
            }}>
              <HMCInfoIconWrapper><MsxIcons name={'search'}></MsxIcons></HMCInfoIconWrapper>
              <HMCTitle>{I10n.get('screen.start_configuration_screen.hmc.button')}</HMCTitle>
            </HMCIconAndTitleWrapper>
          </HMCWrapper>}
          <ConfigurationStarterOptions>
              {options.map((option, idx) => {
                return (
                  <Fragment key={idx}>
                    {option}
                  </Fragment>
                );
              })}
            </ConfigurationStarterOptions>
        </>}
      </>
    );
  }

  renderSoftwareLicenceTechnologies = (optionTypes, availableCallByRangeItems) => {
    const options = [];

    optionTypes.filter(opt => tool_starter_selections.industrial_automation_software.includes(opt)).forEach((optionType) => {
      options.push(
        <CardWrapper lessThan3Options={true}>
          <StartConfigurationCard
            id={optionType}
            title={I10n.get(`screen.start_configuration_screen.create.${optionType}`)}
            description={I10n.get(`screen.start_configuration_screen.create.${optionType}.subtitle`)}
            additionalDescription={I10n.get(`screen.start_configuration_screen.create.${optionType}.additional_description`)}
            value={optionType}
            startLabel={I10n.get('screen.start_configuration_screen.start_now')}
            active={!this.props.configurationSaver.isSaving && !this.state.isLoading}
            onSelection={(value) => {
              const selectedCBRItems = JSON.parse(JSON.stringify(this.props.callByRangeReducer.selectedItems));
              this.selectOnlyRangesAndReferencesForTechnology(availableCallByRangeItems, optionType);
              this.props.createEmptySoftwareLicenceConfiguration().then((payload) => {
                logCreateSoftwareLicenceConfigurationEvent(payload?.configuration?.id, value, this.buildCBREventPayload(selectedCBRItems));
              });
            }}
            renderSelectedFilters={() => { return this.renderFiltersAppliedForTechnology(availableCallByRangeItems, optionType); }}
            primaryColor={appConfiguration.globalStyles.primaryColor}
            secondaryColor={appConfiguration.globalStyles.secondaryColor}
          />
        </CardWrapper>
      );
    });

    return (
      <>
      {options.length > 0 &&  <>
        <ConfigurationOptionsCategory>
            {I10n.get('screen.start_configuration_screen.industrial_automation_softwares')}
          </ConfigurationOptionsCategory>
          <ConfigurationStarterOptions>
            {options.map((option, idx) => {
                return (
                  <Fragment key={idx}>
                    {option}
                  </Fragment>
                );
              })}
          </ConfigurationStarterOptions>
        </>}
      </>
    );
  }

  renderStartTechnologies = (optionTypes, availableCallByRangeItems) => {

    if (appConfiguration.toolMainTechnology === TOOL_MAIN_TECHNOLOGIES.SOFTWARE_LICENCE_CONFIGURATOR) {
      return (
        <>
          {(window.top === window.self || appConfiguration.launchFromWorkspace || appConfiguration.unifiedCheckoutAvailable) && this.renderSoftwareLicenceTechnologies(optionTypes, availableCallByRangeItems)}
          {this.renderModiconTechnologies(optionTypes, availableCallByRangeItems)}
        </>
      );
    }

    return (
      <>
        {this.renderModiconTechnologies(optionTypes, availableCallByRangeItems)}
        {shouldDisplaySoftwareLicenseData() && this.renderSoftwareLicenceTechnologies(optionTypes, availableCallByRangeItems)}
      </>
    );
  }

  renderSavedConfigurations = (filteredConfigurations) => {
    return (
      <SavedConfigurationsList
        isLoading={this.state.isLoading}
        configurations={filteredConfigurations}
        onConfigurationRestore={this.onConfigurationReopen}
        onDuplicate={this.onConfigurationDuplicate}
        onRename={this.onConfigurationRename}
        onDelete={this.onConfigurationDelete}
        onExport={(configuration) => { this.props.exportToXLS(configuration); }}
        onAddToMyProducts={this.addToMyProduct}
        onAddToList={this.addToList}
        onSendMail={this.onSendMail}
        launchFromWorkspace={appConfiguration.launchFromWorkspace}
        isWorkspaceAvailable={appConfiguration.isWorkspaceAvailable}
        unifiedCheckoutAvailable={appConfiguration.unifiedCheckoutAvailable}
        primaryColor={appConfiguration.globalStyles.primaryColor}
        secondaryColor={appConfiguration.globalStyles.secondaryColor}
        active={!this.props.configurationSaver.isSaving}
      >
      </SavedConfigurationsList>
    );
  }

  render = () => {
    const availableCallByRangeItems = this.buildCallByRangeAvailabilities();
    const optionTypes = this.buildOptionTypes(availableCallByRangeItems);
    const filteredConfigurations = this.filterConfigurations();
    return (
      <Wrapper>
        <Header>
          <AppTitle
            selectedLengthUnit={this.props.applicationParameters.lengthUnit}
            setParameters={this.props.setApplicationParameters}
          ></AppTitle>
        </Header>
        <ScreenContent>
          <CallByRange displayableValues={availableCallByRangeItems} selectedValues={this.props.callByRangeReducer.selectedItems} onToggleValue={this.setCBRItem} clearCategory={this.clearCBRCategory} onReset={this.props.resetCallByRangeSelectedItems}>AZGAERGC</CallByRange>
          <TabWrapper>
            <TabItem id='start-configuration-screen-create-start-config' selected={possible_tab_states.technologies === this.state.tabState} onClick={() => {
              this.setState({ tabState: possible_tab_states.technologies });
            }}>
              <TabTitle>
                {I10n.get('screen.start_configuration_screen.create')}
              </TabTitle>
            </TabItem>
            <TabItem id='start-configuration-screen-create-open-config' selected={possible_tab_states.openConfigurations === this.state.tabState} onClick={() => {
              this.setState({ tabState: possible_tab_states.openConfigurations });
            }}>
              <TabTitle>
                {I10n.getAndReplace('screen.start_configuration_screen.load.from_saved', filteredConfigurations.length)}
              </TabTitle>
            </TabItem>
          </TabWrapper>
          <WorkSection>
            {possible_tab_states.technologies === this.state.tabState && this.renderStartTechnologies(optionTypes, availableCallByRangeItems)}
            {possible_tab_states.openConfigurations === this.state.tabState && this.renderSavedConfigurations(filteredConfigurations)}
          </WorkSection>
          <MobileWorkSection>
            <MobileCategoryDropdown id='mobile-start-configuration-screen-create-start-config-mobile' isOpen={this.state.mobileStartConfigurationOpen} onClick={() => { this.setState({ mobileStartConfigurationOpen: !this.state.mobileStartConfigurationOpen, mobileSavedConfigurationsOpen: false }); }}>
              <CategoryDropdownLabel>{I10n.get('screen.start_configuration_screen.create')}</CategoryDropdownLabel>
              <ArrowIconWrapper isOpen={this.state.mobileStartConfigurationOpen}>
                <MsxIcons name="down-arrow" size="small"></MsxIcons>
              </ArrowIconWrapper>
            </MobileCategoryDropdown>
            {this.state.mobileStartConfigurationOpen && this.renderStartTechnologies(optionTypes, availableCallByRangeItems)}
            <MobileCategoryDropdown id='moile-start-configuration-screen-create-open-config-mobile' isOpen={this.state.mobileSavedConfigurationsOpen} onClick={() => { this.setState({ mobileStartConfigurationOpen: false, mobileSavedConfigurationsOpen: !this.state.mobileSavedConfigurationsOpen }); }}>
              <CategoryDropdownLabel>{I10n.getAndReplace('screen.start_configuration_screen.load.from_saved', filteredConfigurations.length)}</CategoryDropdownLabel>
              <ArrowIconWrapper isOpen={this.state.mobileSavedConfigurationsOpen}>
                <MsxIcons name="down-arrow" size="small"></MsxIcons>
              </ArrowIconWrapper>
            </MobileCategoryDropdown>
            {this.state.mobileSavedConfigurationsOpen && this.renderSavedConfigurations(filteredConfigurations)}
          </MobileWorkSection>
          {(window.self === window.top && appConfiguration.seamlessSession == null && [...this.props.mySchneiderCountries].includes(appConfiguration.locale)) && <MobileLoginWrapper>
            <LoginText>{I10n.get('screen.start_configuration_screen.my_schneider_login.modal_body')}</LoginText>
            <Button importance="emphasized" color="secondary" onClick={() => {
              document.location.href = buildMySchneiderUrlWithCBR(this.props.callByRangeReducer?.selectedItems, this.props.shouldHandleDefaultSearchParameters, true);
            }}>
              {I10n.get('app.action.login_register')}
            </Button>
          </MobileLoginWrapper>}
        </ScreenContent>
        {(window.self === window.top && appConfiguration.seamlessSession == null && [...this.props.mySchneiderCountries].includes(appConfiguration.locale)) && <LoginBannerWrapper><LoginBanner
          getLabel={(label) => I10n.get(label)}
          mySchneiderLink={buildMySchneiderUrlWithCBR(this.props.callByRangeReducer?.selectedItems, this.props.shouldHandleDefaultSearchParameters, true)}
          mobileBreakpoint={800}>
        </LoginBanner></LoginBannerWrapper>}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    createEmptyConfiguration: () => dispatch(createEmptyConfiguration()),
    createEmptySoftwareLicenceConfiguration: () => dispatch(createEmptySoftwareLicenceConfiguration()),
    createSoftwareLicenceConfigurationFromSoftware: (softwareSelection) => dispatch(createSoftwareLicenceConfigurationFromSoftware(softwareSelection)),
    closeModal: () => dispatch(closeModal()),
    continue: () => dispatch(setActiveStep(stepsConfig.head_device_selector_screen)),
    getSavedConfigurations: () => dispatch(getSavedConfigurations()),
    getSavedConfigurationByID: (id) => dispatch(getSavedConfigurationByID(id)),
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    updateHandleConfigurationRestore: (status) => dispatch(updateHandleConfigurationRestore(status)),
    renameConfiguration: (configId, configurationName) => dispatch(renameConfiguration(configId, configurationName)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    reopenConfiguration: (configuration) => dispatch(reopenConfiguration(configuration)),
    selectStarter: (selection) => dispatch(setStarterType(selection)),
    exportToXLS: (config) => dispatch(exportToXLS(config, stepsConfig.start_screen)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    exportToMyProduct: (configuration) => dispatch(exportToMyProduct(configuration)),
    setCallByRangeSelectedItems: (items) => dispatch(setCBRSelectedItems(items)),
    resetCallByRangeSelectedItems: () => dispatch(resetCBRSelectedItems()),
    exportToMyProject: (configuration) => dispatch(exportToMyProject(configuration)),
    exportToMyList: (configuration) => dispatch(exportToMyList(configuration)),
    resetShowButtonAnimations: () => dispatch(updateShowButtonAnimations({addToMyProduct: true, survey: true}))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StartConfigurationScreen);
